import { useTranslation } from 'react-i18next';
import type { SelectSellerContactsStepLabels } from '~/components/common/SelectSellerContactsStep';
import { useBuyListSellerPickerLabels } from '~/components/common/useBuyListSellerPickerLabels';

export function useRequestForQuoteSellerContactsLabels(): SelectSellerContactsStepLabels {
  const { t } = useTranslation('inventory');
  const picker = useBuyListSellerPickerLabels({
    loading: t('inventory.buy_list.request_for_quote.sellers_loading'),
    error: t('inventory.buy_list.request_for_quote.sellers_load_failed'),
    emptyMessage: t('inventory.buy_list.request_for_quote.no_sellers'),
  });
  return {
    sellerLists: {
      heading: t('inventory.buy_list.request_for_quote.seller_lists'),
      toggle: (name: string, count: number) =>
        t('inventory.buy_list.request_for_quote.seller_list_toggle', {
          name,
          count,
        }),
    },
    picker,
    row: {
      contactCount: (count: number) =>
        t('inventory.buy_list.request_for_quote.contact_count', { count }),
      noContacts: t('inventory.buy_list.request_for_quote.no_contacts'),
      selectedCount: (count: number) =>
        t('inventory.buy_list.request_for_quote.selected_count', { count }),
      selectOrganization: (name: string) =>
        t('inventory.buy_list.request_for_quote.select_organization', {
          name,
        }),
    },
    selectAll: t('inventory.buy_list.request_for_quote.select_all_sellers'),
  };
}
